export default __webpack_public_path__ + "static/media/제주.d736c65c.svg";